import type { GitHubIntegration } from './useGitHubIntegration';
import type { GitHubRepoSelection } from './useGitHubRepoSelection';
import { useGitHubRepoSelection } from './useGitHubRepoSelection';
import { useLocalStorageRepoSelection } from './useLocalStorageRepoSelection';

/**
 * Repo selection backed by the browser-local slot Vega's surfaces share.
 *
 * Sugar over `useGitHubRepoSelection` + `useLocalStorageRepoSelection` for the common case. It's a
 * separate hook rather than a default on `useGitHubRepoSelection` because hooks can't be called
 * conditionally: a default would subscribe *every* caller to the storage slot, including the ones
 * that persist selection server-side, and `useSafeLocalStorage` re-renders on any change to its key
 * from another surface or tab.
 *
 * Surfaces that persist selection themselves — the alert form, automated cleanup settings — keep
 * calling `useGitHubRepoSelection` with their own storage.
 */
export function useVegaRepoSelection(integration: GitHubIntegration, key?: string): GitHubRepoSelection {
  const storage = useLocalStorageRepoSelection(key);
  return useGitHubRepoSelection({ integration, storage });
}
